export interface Props {
  permissions: string[];
}

export type Badge = 'notLicensed' | 'notAvailable' | 'new' | null;

// A regular route item inside a group or at the top level
export type RouteItem = {
  type: 'route';
  path: string;
  label: string;
  icon: JSX.Element;
  permission?: string | string[]; // string[] → any of them grants access
  requireAllPermissions?: string[]; // all must be present
  licenseKey?: string; // solution feature key — if absent from tenant features → notLicensed
  isNew?: boolean;
  shortLabelKey?: string; // top-level only; i18n key, defaults to `label`
  collapsesAll?: boolean; // top-level only: collapses all groups on click
  exact?: boolean; // don't match sub-routes (e.g. `/fxrates` shouldn't match `/fxrates/setup`)
};

// An action item (no route, runs a callback) — used for KYC
export type ActionItem = {
  type: 'action';
  label: string;
  icon: JSX.Element | ((loading: boolean) => JSX.Element);
  permission?: string;
  onClick: () => void;
};

// An item that is only shown when a runtime condition is true
export type ConditionalItem = {
  type: 'conditional';
  when: boolean;
  item: RouteItem;
};

export type GroupChildItem = RouteItem | ActionItem | ConditionalItem | GroupItem;

// A collapsible group. Can nest inside another GroupItem's children to form a
// sub-group (no depth limit is enforced — the menu structure in practice only
// goes one level deep, but rendering/state handle arbitrary nesting uniformly).
export type GroupItem = {
  type: 'group';
  labelKey: string;
  shortLabelKey?: string; // top-level only (rail tile label); i18n key, defaults to `labelKey`
  icon: JSX.Element;
  paths: string[]; // prefixes used for active-group detection
  children: GroupChildItem[];
};

// A horizontal rule between sections
export type DividerItem = {
  type: 'divider';
};

export type TopLevelEntry = RouteItem | GroupItem | DividerItem;

export const l = (key: string): string => `layout.menu.${key}`;
